import React from "react";
import { useNavigate, Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { getAuth } from "firebase/auth";

function InterviewQuestions() {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleStart = () => {
    if (auth.currentUser) {
      navigate("/");
    } else {
      navigate("/get-started");
    }
  };

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>

      <SEOHead
        title="Interview Questions and Answers (2026 Guide)"
        description="Prepare for your next interview with the most common interview questions and answers. Learn how to respond confidently and get hired faster."
        canonical="https://employpilot.com/interview-questions"
      />

      <h1>Top Interview Questions and How to Answer Them</h1>

      <p style={{ fontSize: "18px", color: "#555" }}>
        Preparing for interviews is one of the most important steps in getting hired.
        Knowing how to answer common questions can give you a huge advantage.
      </p>

      <p style={{ fontWeight: "bold", marginTop: "15px" }}>
        The better your answers, the higher your chances of getting the job.
      </p>

      <button onClick={handleStart} style={btnPrimary}>
        Practice My Answers Now
      </button>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Most Common Interview Questions</h2>

      <h3>Tell me about yourself</h3>
      <p>
        Keep your answer focused on your experience, skills, and what makes you a strong fit for the role.
      </p>

      <h3>Why do you want this job?</h3>
      <p>
        Show that you understand the company and explain how your skills align with the role.
      </p>

      <h3>What are your strengths?</h3>
      <p>
        Highlight strengths that are relevant to the job and support them with examples.
      </p>

      <h3>What are your weaknesses?</h3>
      <p>
        Be honest but show how you are improving and growing.
      </p>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>How to Answer Interview Questions</h2>

      <ul>
        <li>✔ Be clear and structured</li>
        <li>✔ Use real examples</li>
        <li>✔ Stay confident and concise</li>
        <li>✔ Focus on results</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Best Strategy: The STAR Method</h2>

      <p>
        The STAR method helps you answer questions effectively:
      </p>

      <ul>
        <li><strong>Situation:</strong> Set the context</li>
        <li><strong>Task:</strong> Explain your responsibility</li>
        <li><strong>Action:</strong> Describe what you did</li>
        <li><strong>Result:</strong> Share the outcome</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Common Interview Mistakes</h2>

      <ul>
        <li>❌ Not preparing answers</li>
        <li>❌ Giving vague responses</li>
        <li>❌ Lacking confidence</li>
        <li>❌ Not asking questions</li>
      </ul>

      {/* 🔥 INTERNAL LINKS */}
      <p style={{ marginTop: "20px" }}>
        Want to practice with AI?{" "}
        <Link to="/ai-interview-coach">
          Try the AI Interview Coach
        </Link>
      </p>

      <p>
        Need a strong resume first?{" "}
        <Link to="/ai-resume-builder">
          Build your resume here
        </Link>
      </p>

      <p>
        Want to get hired faster?{" "}
        <Link to="/get-job-fast">
          Learn how to get a job fast
        </Link>
      </p>

      {/* CTA */}
      <div style={{ marginTop: "50px", textAlign: "center" }}>
        <h2>Master Your Interview Today</h2>

        <button onClick={handleStart} style={btnSuccess}>
          Start Practicing
        </button>
      </div>

      {/* FAQ SECTION */}
      <h2 style={{ marginTop: "60px" }}>
        Frequently Asked Questions
      </h2>

      <h3>What are the most common interview questions?</h3>
      <p>
        Questions like “Tell me about yourself,” “Why do you want this job,” and “What are your strengths?” are very common.
      </p>

      <h3>How do I prepare for an interview?</h3>
      <p>
        Practice your answers, research the company, and prepare examples of your experience.
      </p>

      <h3>Can AI help with interview preparation?</h3>
      <p>
        Yes. AI tools like EmployPilot can simulate interviews and help improve your responses.
      </p>
<div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "12px 20px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px"
};

const btnSuccess = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer"
};

export default InterviewQuestions;